import React, { ReactElement } from "react";

interface Props {
  label: string;
  children?: React.ReactNode;
  onClick?: () => void;
}

function DotAction({ children, label, onClick }: Props): ReactElement {
  // TODO(tooltip): label with the tooltip
  return (
    <button
      title={label}
      className="w-6 h-6 rounded-full overflow-hidden grid place-content-center"
      type="button"
      onClick={() => onClick?.()}
    >
      {children}
    </button>
  );
}

export default DotAction;
